import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { parse as parseQuery } from 'hub-http/helpers/params';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import TwoFactorRecoveryAdminRecoverForm from './TwoFactorRecoveryAdminRecoverForm';
import { authorizeTwoFactorRemovalByAdmin, updateRecoveryCode, hideInvalidRecoveryCodeAlert, verifyTwoFactorRemovalByAdmin } from '../../actions/twoFactorRecovery';
import { getRecoveryCode, getIsInvalidRecoveryCodeAlertVisible, getAccountEmailToRecover, getHasLoadedAccountEmailToRecover, getIsAdminRecoveryErrorAlertVisible, getHasRemovalAlreadyBeenProcessed, getIsAdminRecoveryRequesting, getDidAdminRecoverySucceed, gethasAdminRecoveryTokenExpired, getIsAdminRecoveryTokenInvalid
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
} from '../../selectors/TwoFactorRecovery';
import { jsx as _jsx } from "react/jsx-runtime";
class TwoFactorRecoveryAdminRecoverPage extends Component {
  constructor(props) {
    super(props);
    this.onCodeChange = e => {
      this.props.updateRecoveryCode(e.target.value);
    };
    this.handleSubmit = event => {
      event.preventDefault();
      const {
        token
      } = this.state;
      const {
        authorizeTwoFactorRemoval,
        recoveryCode
      } = this.props;
      authorizeTwoFactorRemoval(token, recoveryCode);
    };
    const {
      search
    } = props.location;
    const {
      token: _token
    } = parseQuery(search.substr(1));
    this.state = {
      token: _token
    };
  }
  componentDidMount() {
    const {
      token
    } = this.state;
    this.props.verifyTwoFactorRemovalByAdmin(token);
  }
  render() {
    const {
      token
    } = this.state;
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      alignSelf: "center",
      justifyContent: "center",
      flexDirection: "column",
      paddingBlockStart: "500",
      children: /*#__PURE__*/_jsx(View, {
        maxInlineSize: "500px",
        children: /*#__PURE__*/_jsx(TwoFactorRecoveryAdminRecoverForm, Object.assign({
          onSubmit: this.handleSubmit,
          onCodeChange: this.onCodeChange,
          token: token
        }, this.props))
      })
    });
  }
}
TwoFactorRecoveryAdminRecoverPage.propTypes = {
  token: PropTypes.string,
  location: PropTypes.object.isRequired,
  recoveryCode: PropTypes.string.isRequired,
  accountEmailToRecover: PropTypes.string.isRequired,
  isInvalidRecoveryCodeAlertVisible: PropTypes.bool.isRequired,
  hasLoadedAccountEmailToRecover: PropTypes.bool.isRequired,
  isAdminRecoveryErrorAlertVisible: PropTypes.bool.isRequired,
  hasRemovalAlreadyBeenProcessed: PropTypes.bool.isRequired,
  isAdminRecoveryRequesting: PropTypes.bool.isRequired,
  hideInvalidRecoveryCodeAlert: PropTypes.func.isRequired,
  updateRecoveryCode: PropTypes.func.isRequired,
  authorizeTwoFactorRemoval: PropTypes.func.isRequired,
  verifyTwoFactorRemovalByAdmin: PropTypes.func.isRequired,
  hasAdminRecoveryTokenExpired: PropTypes.bool.isRequired,
  isAdminRecoveryTokenInvalid: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  recoveryCode: getRecoveryCode(state),
  isInvalidRecoveryCodeAlertVisible: getIsInvalidRecoveryCodeAlertVisible(state),
  accountEmailToRecover: getAccountEmailToRecover(state),
  hasLoadedAccountEmailToRecover: getHasLoadedAccountEmailToRecover(state),
  isAdminRecoveryErrorAlertVisible: getIsAdminRecoveryErrorAlertVisible(state),
  hasRemovalAlreadyBeenProcessed: getHasRemovalAlreadyBeenProcessed(state),
  isAdminRecoveryRequesting: getIsAdminRecoveryRequesting(state),
  didAdminRecoverySucceed: getDidAdminRecoverySucceed(state),
  hasAdminRecoveryTokenExpired: gethasAdminRecoveryTokenExpired(state),
  isAdminRecoveryTokenInvalid: getIsAdminRecoveryTokenInvalid(state)
});
const reduxConnect = connect(mapStateToProps, {
  authorizeTwoFactorRemoval: authorizeTwoFactorRemovalByAdmin,
  updateRecoveryCode,
  hideInvalidRecoveryCodeAlert,
  verifyTwoFactorRemovalByAdmin
});
export default reduxConnect(TwoFactorRecoveryAdminRecoverPage);